import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { usePolicyControllerPushPolicyEvent } from 'korint-sdk';
import type { PublishEventQuickAction } from 'korint-sdk/react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';

type PublishEventQuickActionDialogProps = {
  action: PublishEventQuickAction;
  onClose: () => void;
};

export function PublishEventQuickActionDialog({
  action,
  onClose,
}: PublishEventQuickActionDialogProps) {
  const { t } = useTranslation();
  const { policy, branchIdForPolicy, mutate } = usePolicyOnDashboard();

  const { mutateAsync: pushPolicyEvent, isPending } = usePolicyControllerPushPolicyEvent();

  async function publish() {
    await pushPolicyEvent({
      policyId: policy.id,
      data: { eventType: action.eventType, data: action.data },
      params: branchIdForPolicy ? { branchId: branchIdForPolicy } : undefined,
    });
    await mutate();
    onClose();
  }

  return (
    <Dialog open onOpenChange={open => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t(`policyQuickActions.${action.id}.confirmTitle`)}</DialogTitle>
          <DialogDescription>
            {t(`policyQuickActions.${action.id}.confirmDescription`)}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isPending}>
            {t('policyQuickActions.cancel')}
          </Button>
          <Button onClick={publish} loading={isPending}>
            {t(`policyQuickActions.${action.id}.submit`)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
